module.exports = __webpack_public_path__ + "img/rakdanit_balet_yes.76073f0e.png";